
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Направления', path: '/directions' },
            { id: 2, name: 'Направления компании', path: '/directions/companies' }
        ]

        return {
            tabs,
        }
    },
})
